import {
	getRequest, postRequest, deleteRequest, patchRequest, storageDateFormat
} from '@/core';
import moment from 'moment';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

async function getUsers({ commit }) {
	commit('set', (state) => { state.loading = true; });
	let response = [];
	try {
		response = await getRequest('/users');
		commit('set', (state) => {
			state.users = response;
		});
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });
	return response;
}

async function updateUser({ state: { users }, commit }, { id,  key, value }) {
	let oldUser = users.find( (x) => x.id === id);
	if (oldUser[key] === value) return;

	let updatedUser = deepCopy(oldUser);
	updatedUser[key] = value;
	updatedUser.editedDate = moment().format(storageDateFormat);
	let patch = rdbClient.createPatch(oldUser, updatedUser);
	let url = `/users/${oldUser.id}`;
	try {
		await patchRequest(url, {}, { patch });
		commit('setUserData', { id, key, value });
		commit('setUserData', { id, key: 'editedDate', value: updatedUser.editedDate });
	} catch (err) {
		throw new Error('failedToUpdate');
	}
}

async function createUser({ commit, dispatch, state }) {
	try {
		await postRequest('/users/createUser', {}, state.newUserData);
		dispatch('getUsers');
	} catch (err) {
		throw new Error('failedToCreate');
	}
	commit('resetNew');
}

async function deleteUsers({ dispatch }, users) {
	let url = '/users/';
	if (!users.length) {
		return;
	} else if (users.length === 1) {
		url += users[0].id;
	}
	let ids = users.map( (x) => x.id );
	try {
		await deleteRequest(url, {}, { ids });
		dispatch('getUsers');
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

export default {
	getUsers,
	updateUser,
	createUser,
	deleteUsers
};